import { defineMessage } from 'react-intl';

const genericErrorMessage = defineMessage({
  id: 'enter.error.generic',
  defaultMessage: 'Something went wrong, please try again later',
  description: 'Generic error message'
});

export {
  genericErrorMessage
};
